import { defineComponent as _defineComponent } from 'vue'
import { FitHalfScreenDialogV2, FitButton } from '@tencent/wphk-ui';
import { i18n } from '@/i18n';
import { ref } from 'vue';
import { language } from '@tencent/ppd-base-libs';

// 暴露方法

export default /*#__PURE__*/_defineComponent({
  __name: 'subway-tip-dialog',
  setup(__props, { expose }) {

expose({ onShowDialog });

// 地铁说明弹窗
const subwayTipDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

// 打开弹窗
function onShowDialog() {
  subwayTipDialog.value?.showDialog();
}

// 关闭弹窗
function onHideDialog() {
  subwayTipDialog.value?.hideDialog();
}

return { __sfc: true,subwayTipDialog, onShowDialog, onHideDialog, FitHalfScreenDialogV2, FitButton, i18n, language }
}

})